import React, { useState, useEffect, useRef } from "react";
import EcommStats from "./child/EcommStats";
import SalesOverviewChart from "./child/SalesOverviewChart";
import TopSellingProductsTable from "./child/TopSellingProductsTable";
import TopCustomersTable from "./child/TopCustomersTable";
import DashboardApi from "../Api/DashboardApi";

const getTodayStr = () => {
  const d = new Date();
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatDateShort = (dateStr) => {
  if (!dateStr) return "";
  const parts = dateStr.split("-").map(Number);
  if (parts.length === 3) {
    const d = new Date(parts[0], parts[1] - 1, parts[2]);
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  }
  return dateStr;
};

const DashBoardLayerEight = () => {
  const [filter, setFilter] = useState("Day");
  const [selectedDate, setSelectedDate] = useState(getTodayStr());
  const dateInputRef = useRef(null);
  const todayStr = getTodayStr();

  const [stats, setStats] = useState({
    totalOrders: 0,
    paidOrders: 0,
    unpaidOrders: 0,
    totalProducts: 0,
    totalCustomers: 0,
    totalRevenue: 0
  });
  const [statsLoading, setStatsLoading] = useState(false);

  useEffect(() => {
    fetchStats();
  }, [filter, selectedDate]);

  const fetchStats = async () => {
    setStatsLoading(true);
    try {
      const dateParam = filter === "Day" ? selectedDate : undefined;
      const response = await DashboardApi.getStats(filter, dateParam);
      if (response.status && response.response.data) {
        setStats(response.response.data);
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setStatsLoading(false);
    }
  };

  return (
    <>
      <div className="row gy-4">
        {/* Dashboard Header */}
        <div className="col-12 mb-2">
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 p-2 bg-white radius-8 shadow-sm px-24 py-16">
            <h6 className="text-primary-600 pb-2 mb-0">Dashboard</h6>
            <div className="btn-group" role="group">
               <style>{`
                 .btn-group .btn {
                   border-radius: 0px !important;
                 }
                 .btn-group > :first-child .btn,
                 .btn-group > .btn:first-child {
                   border-top-left-radius: 8px !important;
                   border-bottom-left-radius: 8px !important;
                 }
                 .btn-group > .btn:last-child {
                   border-top-right-radius: 8px !important;
                   border-bottom-right-radius: 8px !important;
                 }
               `}</style>

              {/* Day filter with integrated date picker */}
              <div className="btn-group position-relative" role="group">
                <button
                  type="button"
                  className={`btn btn-sm px-16 py-8 d-inline-flex align-items-center gap-2 ${filter === "Day" ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => {
                    if (filter !== "Day") {
                      setFilter("Day");
                    } else if (selectedDate !== todayStr) {
                      setSelectedDate(todayStr);
                    } else {
                      dateInputRef.current?.showPicker?.();
                    }
                  }}
                  style={{ fontSize: '14px', borderRadius: '0px' }}
                  title={filter === "Day" && selectedDate !== todayStr ? "Click to reset to Today, or click calendar icon to choose date" : "Click to select date"}
                >
                  <span>
                    {filter === "Day" && selectedDate !== todayStr
                      ? `Day: ${formatDateShort(selectedDate)}`
                      : "Day"}
                  </span>
                  <span
                    className="d-inline-flex align-items-center position-relative"
                    style={{ cursor: 'pointer' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setFilter("Day");
                      dateInputRef.current?.showPicker?.();
                    }}
                  >
                    <i className="ri-calendar-line" style={{ fontSize: '15px' }}></i>
                    <input
                      ref={dateInputRef}
                      type="date"
                      max={todayStr}
                      value={selectedDate}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => {
                        if (e.target.value) {
                          setSelectedDate(e.target.value);
                          setFilter("Day");
                        }
                      }}
                      style={{
                        position: 'absolute',
                        inset: 0,
                        opacity: 0,
                        cursor: 'pointer',
                        width: '100%',
                        height: '100%'
                      }}
                      title="Choose date"
                    />
                  </span>
                </button>
              </div>

              {["Weekly", "Monthly", "Yearly"].map((f) => (
                <button
                  key={f}
                  type="button"
                  className={`btn btn-sm px-20 py-8 ${filter === f ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setFilter(f)}
                  style={{ fontSize: '14px', borderRadius: '0px' }}
                >
                  {f}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="col-12">
          {/* Top Summary Stats */}
          <EcommStats stats={stats} loading={statsLoading} />

          {/* Sales Overview Chart */}
          <SalesOverviewChart filter={filter} date={filter === "Day" ? selectedDate : undefined} />

          <div className="row gy-4">
            <div className="col-xxl-6">
              {/* Top Selling Products */}
              <TopSellingProductsTable filter={filter} date={filter === "Day" ? selectedDate : undefined} />
            </div>
            <div className="col-xxl-6">
              {/* Top Customers */}
              <TopCustomersTable filter={filter} date={filter === "Day" ? selectedDate : undefined} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};



export default DashBoardLayerEight;
